import { render, staticRenderFns } from "./RmaQuestionnaires.vue?vue&type=template&id=a9b7185e&scoped=true"
import script from "./RmaQuestionnaires.vue?vue&type=script&lang=js"
export * from "./RmaQuestionnaires.vue?vue&type=script&lang=js"
import style0 from "./RmaQuestionnaires.vue?vue&type=style&index=0&id=a9b7185e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b7185e",
  null
  
)

export default component.exports